module.exports = __webpack_public_path__ + "img/app-dne-download-ios.a3744c32.svg";